import React from 'react';
import { Alert } from 'housecall-ui';

export const DataError = () => {
  return (
    <Alert severity="warning" role="status">
      Sorry, services are currently unavailable. Please try refreshing the page. If the issue persists, please
      don&apos;t hesitate to contact our support team for assistance.
    </Alert>
  );
};
